module.exports = __webpack_public_path__ + "static/media/stofferingen-04.82267e71.jpg";